module.exports = __webpack_public_path__ + "static/media/t_home.1b2ba825.svg";